import { Deal } from '~/types/deal';
import { DISCUSSION } from './constants';

export type DiscussionSort =
  | 'latest'
  | 'date'
  | 'newest'
  | 'oldest'
  | 'helpful'
  | 'rating:asc'
  | 'rating:desc';

export interface DiscussionSortOption {
  value: DiscussionSort;
  label: string;
}

export type DiscussionFilter =
  | 'all'
  | 'unresolved'
  | 'unapproved'
  | 'needs_reply';

export interface DiscussionFilterOption {
  value: DiscussionFilter;
  label: string;
}

export type CommentUser = {
  id: number;
  avatar: string;
  username: string;
  date_joined: string;
  deals_purchased: number;
  comment_whitelist: boolean;
  comment_blacklist: boolean;
  has_briefcase?: boolean;
  has_plus?: boolean;
};

export type QuestionV2 = {
  id: number;
  display_path: string;
  parent_id?: number;
  deal_id: number;
  level: number;
  href: string;
  user: CommentUser;
  created: string;
  modified: string;
  purchased: boolean;
  title: string;
  comment: string;
  approved: boolean;
  resolved: boolean;
  up_votes: number;
  down_votes: number;
  user_vote: number;
  children?: CommentV2[];
  status: DiscussionStatus;
};

export type ReviewV2 = {
  id: number;
  display_path: string;
  parent_id?: number;
  deal_id: number;
  level: number;
  href: string;
  user: CommentUser;
  created: string;
  modified: string;
  purchased: boolean;
  title: string;
  comment: string;
  approved: boolean;
  resolved: boolean;
  rating: number;
  up_votes: number;
  user_vote: number;
  down_votes: number;
  would_recommend: boolean;
  review_dimensions: {
    slug: string;
    name: string;
    rating: number;
  }[];
  children?: CommentV2[];
  status: DiscussionStatus;
};

export type CommentV2 = QuestionV2 | ReviewV2;

export interface DiscussionStatusTag {
  text: string;
  className: string;
}

export type DiscussionType =
  | typeof DISCUSSION.QUESTIONS
  | typeof DISCUSSION.REVIEWS;

export interface QuestionPageProps {
  deal: Deal;
  discussion: {
    comments: [QuestionV2];
    meta: Record<string, any>;
  };
  discussionId: number;
  useQuestions2_5UI?: boolean;
}

export interface ReviewPageProps {
  deal: Deal;
  discussion: {
    comments: [ReviewV2];
    meta: Record<string, any>;
  };
  discussionId: number;
  useReviews2_5UI?: boolean;
}

export interface DiscussionQuestion {
  comments: [QuestionV2];
  meta: Record<string, any>;
  redirect?: string;
}

export interface DiscussionReview {
  comments: [ReviewV2];
  meta: Record<string, any>;
  redirect?: string;
}

export type DiscussionComment = DiscussionQuestion | DiscussionReview;

export const DISCUSSION_STATUS_UNMODERATED = 'unmoderated';
export const DISCUSSION_STATUS_APPROVED = 'approved';
export const DISCUSSION_STATUS_REJECTED = 'rejected';

export type DiscussionStatus =
  | typeof DISCUSSION_STATUS_UNMODERATED
  | typeof DISCUSSION_STATUS_APPROVED
  | typeof DISCUSSION_STATUS_REJECTED;
